<template>
<div>
  <el-tabs class="tab-button" v-model="activeTab">
    <el-tab-pane label="E2E 플로우 맵" name="e2eFlowMap">
      <w-e2-e-flow-map :flowData="flowMapData" @time-type-change="setTimeType('e2eFlowMap', $event)" @reload="selectedTabTableLoad"/>
    </el-tab-pane>
    <el-tab-pane label="에이전트별 현황" name="agentStatus">
      <w-agent-status-table :tableData="agentStatusTableData" @time-type-change="setTimeType('agentStatus', $event)" @reload="selectedTabTableLoad"/>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import { analysisTimeType, defaultAnalysisTimeType } from '@/constants/performance';
import e2eTableInfoAPI from '@/api/performance/e2e/e2e-table-info';
import AnalysisTable from '@/mixins/performance/analysis-table';
import WAgentStatusTable from '@/views/performance/node/analysis/e2e/components/AgentStatusTable';
import WE2EFlowMap from '@/views/performance/node/analysis/e2e/components/E2EFlowMap';
import isNil from 'lodash/isNil';
import { mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'WPerformanceE2eAnalysisTable',
  components: {
    WAgentStatusTable,
    WE2EFlowMap,
  },
  mixins: [AnalysisTable],
  data() {
    return {
      analysisTimeType,
      activeTab: 'e2eFlowMap',
      agentStatusTableData: {},
      flowMapData: {},
      timeType: {
        e2eFlowMap: defaultAnalysisTimeType,
        agentStatus: defaultAnalysisTimeType,
      },
      isChangeNodeFlag: true, // true일 경우 (현재/이력) 모든 부분을 이력으로 변경한다.
    };
  },
  computed: mapGetters(['selectedNode', 'plotLineDatetime']),
  watch: {
    /**
     * [plotLineDatetime 차트 클릭시 테이블 데이터 로드]
     * @author {Yang}
     * @return {[type]} [description]
     */
    plotLineDatetime() {
      this.selectedTabTableLoad();
    },
    /**
     * [activeTab 탭 선택시 로드]
     * @author {Yang}
     * @return {[String]}
     */
    activeTab() {
      this.selectedTabTableLoad();
    },
    active(active) {
      if (active) {
        this.selectedTabTableLoad();
      }
    },
    selectedNode: {
      handler() {
        if (!this.active) {
          return;
        }
        this.isChangeNodeFlag = true;
      },
      immediate: true,
    },
  },
  methods: {
    selectedTabTableLoad() {
      if ((isNil(this.plotLineDatetime)) || !this.active || isEmpty(this.selectedNode)) {
        return;
      }
      if (this.isChangeNodeFlag) {
        this.clearTimeType();
        this.$nextTick(() => {
          this.loadTableDataList();
          this.isChangeNodeFlag = false;
        });
      } else {
        this.loadTableDataList();
      }
    },
    /**
     * [ e2e플로우 맵 리스트 출력]
     * @author {Yang}
     * @return {[type]} [description]
     */
    e2eFlowMapLoadStore() {
      if (this.timeType.e2eFlowMap === this.analysisTimeType.HIST.value) {
        const params = {
          objId: this.selectedNode.obj.objId,
          baselineDatetime: this.plotLineDatetime,
          managetypeId: 'E2E',
        };
        e2eTableInfoAPI.getE2eFlowMapList(params).then((result) => {
          if (result.data.success) {
            this.flowMapData = result.data.data;
            this.flowMapData.timeType = this.timeType.e2eFlowMap;
          }
        });
      } else {
        const params = {
          objId: this.selectedNode.obj.objId,
          managetypeId: 'E2E',
        };
        e2eTableInfoAPI.getCurrentAgentStatusList(params).then((result) => {
          if (result.data.success) {
            this.$set(this.flowMapData, 'currentList', result.data.data);
            this.flowMapData.timeType = this.timeType.e2eFlowMap;
          }
        });
      }
    },
    /**
     * [ agentStatus 리스트 출력]
     * @author {Yang}
     * @return {[type]} [description]
     */
    agentStatusLoadStore() {
      if (this.timeType.agentStatus === this.analysisTimeType.HIST.value) {
        const params = {
          objId: this.selectedNode.obj.objId,
          baselineDatetime: this.plotLineDatetime,
          managetypeId: 'E2E',
        };
        e2eTableInfoAPI.getE2eAgentStatusList(params).then((result) => {
          if (result.data.success) {
            this.agentStatusTableData = result.data.data;
            this.agentStatusTableData.timeType = this.timeType.agentStatus;
          }
        });
      } else {
        const params = {
          objId: this.selectedNode.obj.objId,
          managetypeId: 'E2E',
        };
        e2eTableInfoAPI.getCurrentAgentStatusList(params).then((result) => {
          if (result.data.success) {
            this.$set(this.agentStatusTableData, 'currentList', result.data.data);
            this.agentStatusTableData.timeType = this.timeType.agentStatus;
          }
        });
      }
    },
    /**
     * [selectionTabTableLoad 선택된 탭의 테이블 로드]
     * @author {Yang}
     * @return {[type]} [description]
     */
    loadTableDataList() {
      if ((!isNil(this.plotLineDatetime)) && (this.selectedNode.subType === 'e2e')) {
        switch (this.activeTab) {
          case 'e2eFlowMap':
            this.e2eFlowMapLoadStore();
            break;
          case 'agentStatus':
            this.agentStatusLoadStore();
            break;
          default:
            this.e2eFlowMapLoadStore();
        }
      }
    },
    setTimeType(type, value) {
      this.timeType[type] = value;
      this.selectedTabTableLoad();
    },
    clearTimeType() {
      const hist = defaultAnalysisTimeType;
      this.$set(this.timeType, 'e2eFlowMap', hist);
      this.$set(this.timeType, 'agentStatus', hist);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/e2e/PerformanceE2eAnalysisTable.vue